
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.827 18.984l-4.861-4.861a8.495 8.495 0 002.093-5.593C17.06 3.823 13.231 0 8.53 0 3.824 0 0 3.828 0 8.53c0 4.701 3.828 8.53 8.53 8.53 2.138 0 4.094-.79 5.593-2.094l4.861 4.861c.116.115.27.177.422.177a.6.6 0 00.421-1.02zM1.193 8.53c0-4.046 3.291-7.332 7.332-7.332 4.045 0 7.332 3.29 7.332 7.332 0 4.04-3.287 7.336-7.332 7.336-4.04 0-7.332-3.291-7.332-7.336z","fill":"#908F8D"}})])
          )
        }
      }
    